import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
// material-ui
import Badge from '@mui/material/Badge';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import CardContent from '@mui/material/CardContent';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Avatar from 'components/@extended/Avatar';
import MainCard from 'components/MainCard';
import Transitions from 'components/@extended/Transitions';
import IconButton from 'components/@extended/IconButton';
import { ThemeMode } from 'contexts/config';
// assets
import avatar1 from '../../../../../pages-new/auth/auth1/Image/user.png';
import { Logout } from 'iconsax-react';
import { useAuth } from 'hooks';
import { useNavigate } from 'react-router-dom';
// tab panel wrapper
function TabPanel({ children, value, index, ...other }) {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
      sx={{ p: 1 }}
    >
      {value === index && children}
    </Box>
  );
}
// ==============================|| HEADER CONTENT - PROFILE ||============================== //
export default function ProfilePage() {
  const theme = useTheme();
  const navigate = useNavigate()
  const { logout,user } = useAuth()
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const iconBackColorOpen = theme.palette.mode === ThemeMode.DARK ? 'background.paper' : 'secondary.200';
  const iconBackColor = theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'secondary.100';
  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <ButtonBase
        sx={{
          p: 0.25,
          borderRadius: 1,
          '&:hover': { bgcolor: theme.palette.mode === ThemeMode.DARK ? 'secondary.light' : 'secondary.lighter' },
          '&:focus-visible': {
            outline: `2px solid ${theme.palette.secondary.dark}`,
            outlineOffset: 2
          }
        }}
        aria-label="open profile"
        ref={anchorRef}
        aria-controls={open ? 'profile-grow' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        <Avatar alt="profile user" src={ user?.profileImage || avatar1} />
      </ButtonBase>
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{   strategy: 'fixed',modifiers: [{ name: 'offset', options: { offset: [0, 9] } }] }}
      >
        {({ TransitionProps }) => (
          <Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
            <Paper
              sx={{
                boxShadow: theme.customShadows.z1,
                width: 190,
                minWidth: 200,
                maxWidth: 350,
                [theme.breakpoints.down('md')]: { maxWidth: 250 },
                borderRadius: 1.5
              }}
            >
              <ClickAwayListener onClickAway={handleClose} className="profile-tab">
                <MainCard border={false} content={false}>
                  <CardContent sx={{ px: 1.5, pt: 3 }} className="profile-pad">
                    <Grid container justifyContent="space-between" alignItems="center">
                      <Grid item>
                        <Stack direction="row" spacing={1.01} alignItems="center">
                          <Stack>
                            <Typography variant="subtitle1">{user.firstName} {user.lastName}</Typography>
                            <Typography variant="body2" color="secondary">
                              {user?.roles[0]?.role}
                            </Typography>
                          </Stack>
                          <Box sx={{ flexShrink: 0, ml: 0.5 }}>
                            <IconButton
                              color="secondary"
                              variant="light"
                              aria-label="open profile"
                              // ref={anchorRef}
                              aria-controls={open ? 'profile-grow' : undefined}
                              aria-haspopup="true"
                              onClick={() => {
                                logout()
                                navigate('/')
                              }}
                              size="large"
                              sx={{ color: 'secondary.main', bgcolor: open ? iconBackColorOpen : iconBackColor, p: 1 }}
                            >
                              {/* badgeContent={read} */}
                              <Badge
                                color="success"
                                sx={{ '& .MuiBadge-badge': { top: 2, right: 4 } }}
                              >
                                <Logout />
                              </Badge>
                            </IconButton>
                          </Box>
                        </Stack>
                      </Grid>
                    </Grid>
                  </CardContent>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
}

TabPanel.propTypes = { children: PropTypes.node, value: PropTypes.number, index: PropTypes.number, other: PropTypes.any };
